<script setup>
import XlButton from '../xl/XlButton.vue';

/**
 * The frame a full-page editor sits in: a way back, and a heading that says
 * which one you are in. The modal it replaces carries both in its chrome;
 * a page has to say them out loud.
 */
defineProps({
  title: { type: String, required: true },
  backLabel: { type: String, required: true },
});
const emit = defineEmits(['back']);
</script>

<template>
  <div class="content-page-shell">
    <XlButton variant="ghost" class="content-page-shell__back" @click="emit('back')">
      <template #icon>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m14.5 5-7 7 7 7" /></svg>
      </template>
      {{ backLabel }}
    </XlButton>
    <h2 class="content-page-shell__title">{{ title }}</h2>
    <slot />
  </div>
</template>

<style scoped>
.content-page-shell { font-family: var(--xl-font-family); }

.content-page-shell__back { margin-bottom: 18px; }

.content-page-shell__title {
  margin: 0 0 20px;
  font-size: 26px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--xl-color-primary-text, #1d1b20);
}
</style>
